import { ReactNode } from 'react';

import Hint from '~/components/scales/Hint/Hint';

export default function UploadHeader(props: {
  label?: string;
  onHelp?: () => void;
  tooltip?: ReactNode;
}) {
  return (
    <div className="flex items-center gap-2 type-heading2" data-cy="import-text-header">
      {props.label}
      {props.tooltip && (
        <div onMouseEnter={props.onHelp}>
          <Hint content={props.tooltip} />
        </div>
      )}
    </div>
  );
}
